<template>
    <div class="edit-super-admin">
        <div class="card">
            <div class="card-body">
                <div class="left-side">
                    <h3 class="title-header">Edit user</h3>
                    <h4 class="section-header">Assign role</h4>
                    <select class="custom-select form-control" v-model="roleId" @change="getInitialPermissions()">
                        <option value="5" selected>Super Admin</option>
                        <option value="8">Support</option>
                        <option value="6">Fulfilment</option>
                        <option value="10">Sales</option>
                    </select>
                    <h4 class="title-header">User info</h4>
                    <fieldset :class="[errors && errors.has('new-user-firstname') ? 'error-field' : '']">
                        <label for="new-user-firstname">First Name</label>
                        <input type="text" id="new-user-firstname" class="form-control" v-validate="'required'" data-vv-as="New user first name" name="new-user-firstname" v-model="firstName">
                        <span v-show="errors && errors.has('new-user-firstname')" class="validate-warning">{{ errors.first('new-user-firstname') }}</span>
                    </fieldset>
                    <fieldset :class="[errors && errors.has('new-user-lastname') ? 'error-field' : '']">
                        <label for="new-user-lastname">Last Name</label>
                        <input type="text" id="new-user-lastname" class="form-control" v-validate="'required'" data-vv-as="New user last name" name="new-user-lastname" v-model="lastName">
                        <span v-show="errors && errors.has('new-user-lastname')" class="validate-warning">{{ errors.first('new-user-lastname') }}</span>
                    </fieldset>
                    <fieldset :class="[errors && errors.has('new-user-email') ? 'error-field' : '']">
                        <label for="new-user-email">Email</label>
                        <input type="text" id="new-user-email" class="form-control" disabled="true" v-validate="'required|email'" data-vv-as="New user email" name="new-user-email" v-model="email">
                        <span v-show="errors && errors.has('new-user-email')" class="validate-warning">{{ errors.first('new-user-email') }}</span>
                    </fieldset>
                    <button class="btn btn-primary reset-pswd-btn" @click="showResetPasswordModal()">Reset password</button>
                    <div class="disable-btn-box">
                        <button :class="['btn', 'btn-success', disabled ? '' : 'hidden']" @click="reactivateUser()">Re-activate User</button>
                        <button :class="['btn', 'btn-error', disabled ? 'hidden' : '']" @click="showDisableUserModal()">Disable User</button>
                    </div>
                </div>
                <div class="right-side">
                    <h3 class="title-header">Set permissions</h3>
                    <h4 class="permissions-subtitle">Company Specific</h4>
                    <div class="permissions-checkboxes">
                        <div v-for="perm of companyPermissions">
                            <div v-if="perm.code == 'ALL_COMPANIES_ACCESS'">
                                <div class="permission-item">
                                    <div class="radio-box">
                                        <input type="radio" id="all-company-access" name="company-access" v-model="perm.selected" value="ALL_COMPANIES_ACCESS">
                                        <label for="all-company-access"><span>{{perm.name}}</span></label>
                                    </div>
                                    <div class="description">{{perm.description}}</div>
                                </div>
                                <div class="permission-item">
                                    <div class="radio-box">
                                        <input type="radio" id="company-access" name="company-access" v-model="perm.selected" value="ONLY_SELECTED_COMPANIES">
                                        <label for="company-access"><span>Company access</span></label>
                                    </div>
                                    <div class="description">User will have access to selected companies</div>
                                </div>
                                <div class="companies-select-dropdown">
                                    <div class="companies-select">
                                        <div class="fts-dropdown" v-click-outside="closeDropdownCompany">
                                            <div :class="['dropdown-control', openedDropdownCompany ? 'straight-border' : '']" @click="openCloseDropdownCompany">
                                                <span class="dropdown-title" v-if="selectedCompanies.length == 0">{{dropdownTitleCompany}}</span>
                                                <div v-else class="selected-list">
                                                    <div v-for="selected in displaySelectedCompanies" class="selected-item">
                                                        {{selected.label}}
                                                        <i class="fa fa-times-circle" @click.stop="deselectOptionCompanies(selected)"></i>
                                                    </div>
                                                </div>
                                                <span class="count-hidden">
                                                {{countHiddenCompanies}}
                                                </span>
                                                <i :class="['fa', openedDropdownCompany ? 'fa-caret-up' : 'fa-caret-down']"></i>
                                            </div>
                                            <div :class="['dropdown-list', openedDropdownCompany ? 'list-visible' : '']">
                                                <div class="dropdown-search">
                                                    <i class="fa fa-search"></i>
                                                    <input v-model="searchedPhraseCompany" type="text" placeholder="Search" @keyup="searchPhraseCompanies"/>
                                                </div>
                                                <div class="dropdown-options">
                                                    <div class="dropdown-option">
                                                        <label class="dropdown-label" :for="'company-option0'" :option-selected="isAllRowSelected()">
                                                            <input class="dropdown-checkbox" :id="'company-option0'" type="checkbox" :checked="isAllRowSelected()" @change="selectAllOptionCompany()">
                                                            <span></span>
                                                            <span class="option-content">Select All Companies</span>
                                                        </label>
                                                    </div>
                                                    <div class="dropdown-option" v-for="row in displayedCompanies">
                                                        <label class="dropdown-label" :for="'company-option' + row.value" :option-selected="row.selected">
                                                            <input class="dropdown-checkbox" :id="'company-option' + row.value" type="checkbox" :checked="row.selected" @change="selectOptionCompany(row)">
                                                            <span></span>
                                                            <span class="option-content">{{row.label}}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="clear-box">
                                                    <button class="btn btn-light clear-btn" @click="clearCompaniesDropdown">Clear</button>
                                                </div>
                                            </div>
                                        </div>
                                        <p>{{selected.companies}}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="permission-item">
                                <div class="checkbox-box">
                                    <FTScheckbox v-model="perm.selected" :label="perm.name"></FTScheckbox>
                                </div>
                                <div class="description">{{perm.description}}</div>
                            </div>
                        </div>
                    </div>
                    <h4 class="permissions-subtitle">Super Admin Specific</h4>
                    <div class="permissions-checkboxes">
                        <div v-for="perm of adminPermissions" :class="['permission-item', perm.name != 'Super Admin Panel' ? '' : 'hide-perm']">
                            <div class="checkbox-box">
                                <FTScheckbox v-model="perm.selected" :label="perm.name"></FTScheckbox>
                            </div>
                            <div class="description">{{perm.description}}</div>
                        </div>
                    </div>
                    <div class="control-bar">
                        <a @click="getInitialPermissions()">Reset permissions</a>
                        <div class="buttons-box">
                            <button class="btn btn-light" @click="cancelEdition()">Cancel</button>
                            <button class="btn btn-success" :disabled="checkChanges() == false" @click="changeSuperAdmin()">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="disableUserModal" id="disableUserModal" centered :class="['delete-user-modal']" hide-footer>
            <img  src="../../assets/img/unsaved-data.png" alt />

            <h3>Disable user</h3>
            <h4>Are you sure you want to disable this user?<br/>
                Ability to login will be blocked.</h4>
            <div class="button-wrapper">
                <b-button variant="light" @click="$refs['disableUserModal'].hide()">Cancel</b-button>
                <b-button variant="success" @click="disableUser()">Yes, disable user</b-button>
            </div>
        </b-modal>

        <b-modal ref="unsaved" id="unsaved" :class="['unsaved-edit-user']" centered hide-footer>
            <img  src="../../assets/img/unsaved-data.png" alt />

            <h3>Unsaved Data</h3>
            <h4>User edition will not be saved, do you wan to continue?</h4>
            <div class="button-wrapper">
                <b-button variant="danger" @click="$refs['unsaved'].hide()">Cancel</b-button>
                <b-button variant="success" @click="goBackToUsersPermissions">Continue</b-button>
            </div>
        </b-modal>
        <b-modal ref="resetPassword" id="resetPassword" class="modal-reset-password" hide-footer centered>
            <i class="fa fa-lock" aria-hidden="true"></i>
            <h3>Reset Password</h3>
            <h4>Do you really want reset password?</h4>
            <div class="button-wrapper">
                <b-button variant="danger" @click="hideResetPasswordModal()">No</b-button>
                <b-button variant="success" @click="resetAdminPassword()">Yes</b-button>
            </div>
        </b-modal>
    </div>
</template>


<script>
    import Axios from 'axios'
    import globalStore from "../../variables";
    import VeeValidate from "vee-validate";
    import Vue from "vue";
    import FTScheckbox from "../../ftsComponents/FTScheckbox";
    import VueCookies from "vue-cookies";
    import globalStorage from "../../variables";

    const veeValidateConfig = {};

    Vue.use(VeeValidate, veeValidateConfig);
    Vue.use(VueCookies);
    Vue.$cookies.config('7d','','',true)

    export default {
        name: "EditSuperAdmin",
        components: {
            FTScheckbox
        },
        data() {
            return {
                companiesList: [],
                displayedCompanies: [],
                searchedPhraseCompany: '',
                countHiddenCompanies: '',
                selected: {
                    companies: ''
                },
                openedDropdownCompany: false,
                selectedCompanies: [],
                displaySelectedCompanies: [],
                dropdownTitleCompany: 'Companies',
                permissions: {
                    editPaySettings: false,
                    editOtherSettings: false,
                    editCompanyAllowances: false,
                    performActionsOnCompany: false,
                    editPlanPricing: false,
                    manageCouponCodes: false,
                    errorLogsAccess: false,
                    orderManagement: false,
                    tfbQueueManagement: false,
                    superAdminReportsAccess: false,
                    billingReportsAccess: false,
                    genesisUsageAccess: false,
                    simQuery: false,
                    registrationEnrollment: false,
                    dailySalesReports: false,
                    systemHealth: false,
                    coldStockManagement: false
                },
                companiesAccess: '',
                initialCompaniesAccess: '',
                roleId: 5,
                firstName: '',
                lastName: '',
                email: '',
                disabled: false,
                blockSave: false,
                initialData: {},
                companyPermissions: [],
                adminPermissions: [],
                initialCompanyPermissions: [],
                initialAdminPermissions: []
            }
        },
        methods: {
            getPermissionsList() {
                Axios.get(globalStore.data.restApiUrl + '/admin/super-admin-permissions')
                    .then(response => {
                        for (let item of response.data) {
                            if (item.permissionType == 'COMPANY_SPECIFIC') {
                                for (let permission of item.typePermissions) {
                                    if (permission.code == 'ALL_COMPANIES_ACCESS') {
                                        permission.selected = 'ALL_COMPANIES_ACCESS'
                                        this.companyPermissions.push(permission)
                                    } else {
                                        permission.selected = false
                                        this.companyPermissions.push(permission)
                                    }
                                }
                            } else if (item.permissionType == 'SUPER_ADMIN_SPECIFIC') {
                                for (let permission of item.typePermissions) {
                                    if (permission.name != 'Super Admin Panel') {
                                        permission.selected = false
                                        this.adminPermissions.push(permission)
                                    } else {
                                        permission.selected = true
                                        this.adminPermissions.push(permission)
                                    }
                                }
                            }
                        }
                        this.setPermissions(this.initialData.userPermissions)
                    })
            },
            getInitialPermissions() {
                Axios.get( globalStore.data.restApiUrl + '/admin/users/permissions?roleId=' + this.roleId)
                    .then(response => {
                        this.setPermissions(response.data)
                        this.selectedCompanies = []
                        for (let company of this.companiesList) {
                            if (this.initialData.associatedCompanyIds.indexOf(company.value) > -1) {
                                this.selectedCompanies.push({label: company.label, value: company.value, selected: true})
                                company.selected = true
                            } else {
                                company.selected = false
                            }
                        }

                        if (this.selectedCompanies.length > 0) {
                            if (this.selectedCompanies.length == 1) {
                                this.selected.companies = '1 company selected'
                                this.countHiddenCompanies = ''
                            } else {
                                this.countHiddenCompanies = '...'
                                this.selected.companies = this.selectedCompanies.length + ' companies selected'
                            }
                        } else {
                            this.countHiddenCompanies = ''
                            this.selected.companies = 'None selected'
                        }
                    })
            },
            setPermissions(permissions) {
                this.initialCompanyPermissions = []
                this.initialAdminPermissions = []
                for (let perm of this.companyPermissions) {
                    if (permissions.indexOf(perm.code) > -1) {
                        if (perm.code == 'ALL_COMPANIES_ACCESS') {
                            perm.selected = 'ALL_COMPANIES_ACCESS'
                        } else {
                            perm.selected = true
                        }
                    } else {
                        perm.selected = false
                    }
                    if (perm.code == 'ALL_COMPANIES_ACCESS' && perm.selected != 'ALL_COMPANIES_ACCESS') {
                        perm.selected = 'ONLY_SELECTED_COMPANIES'
                    }
                    this.initialCompanyPermissions.push({code: perm.code, description: perm.description, name: perm.name, selected: perm.selected ? perm.selected : false})
                }
                for (let perm of this.adminPermissions) {
                    if (permissions.indexOf(perm.code) > -1) {
                        perm.selected = true
                    } else {
                        perm.selected = false
                    }
                    this.initialAdminPermissions.push({code: perm.code, description: perm.description, name: perm.name, selected: perm.selected ? true : false})
                }
            },
            getCompaniesList() {
                Axios.get(`${globalStore.data.restApiUrl}/admin/accounts?page=1&size=1000&sort=2&desc=false`)
                    .then(response => {
                        this.companiesList = [];
                        this.selectedCompanies = [];
                        for (let company of response.data.selectedCompanies.response) {
                            if (this.initialData.associatedCompanyIds.indexOf(company.companyId) > -1) {
                                this.companiesList.push(
                                    {
                                        value: company.companyId,
                                        label: company.companyName,
                                        selected: true
                                    }
                                )
                                this.selectedCompanies.push(
                                    {
                                        value: company.companyId,
                                        label: company.companyName,
                                        selected: true
                                    }
                                )
                            } else {
                                this.companiesList.push(
                                    {
                                        value: company.companyId,
                                        label: company.companyName,
                                        selected: false
                                    }
                                )
                            }
                        }

                        if (this.selectedCompanies.length > 0) {
                            if (this.selectedCompanies.length == 1) {
                                this.selected.companies = '1 company selected'
                                this.countHiddenCompanies = ''
                            } else {
                                //let countCompanies = this.selectedCompanies.length;
                                this.countHiddenCompanies = '...'
                                this.selected.companies = this.selectedCompanies.length + ' companies selected'
                            }
                        } else {
                            this.countHiddenCompanies = ''
                            this.selected.companies = 'None selected'
                        }

                        this.displaySelectedCompanies = this.selectedCompanies.slice(0,1);

                        this.displayedCompanies = this.companiesList;
                    })
            },
            searchPhraseCompanies() {
                if (this.searchedPhraseCompany != '') {
                    this.displayedCompanies = this.companiesList.filter(item => {
                        return item.label.toLowerCase().indexOf(this.searchedPhraseCompany.toLowerCase()) != -1 ? item : null;
                    })
                } else {
                    this.displayedCompanies = this.companiesList;
                }
            },
            selectAllOptionCompany() {
                for (let company in this.displayedCompanies) {
                    this.selectOptionCompany(this.displayedCompanies[company])
                }
            },
            selectOptionCompany(option) {
                option.selected = !option.selected;
                if (option.selected)
                    this.selectedCompanies.push(option);
                else
                    this.selectedCompanies = this.selectedCompanies.filter(item => {
                        return option.value != item.value
                    })

                if (this.selectedCompanies.length > 0) {
                    if (this.selectedCompanies.length == 1) {
                        this.selected.companies = '1 company selected'
                        this.countHiddenCompanies = ''
                    } else {
                        //let countCompanies = this.selectedCompanies.length;
                        this.countHiddenCompanies = '...'
                        this.selected.companies = this.selectedCompanies.length + ' companies selected'
                    }
                } else {
                    this.countHiddenCompanies = ''
                    this.selected.companies = 'None selected'
                }

                this.displaySelectedCompanies = this.selectedCompanies.slice(0,1);
                if (this.selectedCompanies.length > 0 && this.companiesAccess != 'ONLY_SELECTED_COMPANIES') {
                    this.companiesAccess = 'ONLY_SELECTED_COMPANIES'
                }
            },
            deselectOptionCompanies(option) {
                this.selectedCompanies = this.selectedCompanies.filter(item => {
                    return option.value != item.value
                })
                for (let item of this.companiesList) {
                    if (item.value == option.value) {
                        item.selected = false;
                    }
                }
                for (let item of this.displayedCompanies) {
                    if (item.value == option.value) {
                        item.selected = false;
                    }
                }

                if (this.selectedCompanies.length > 0) {
                    if (this.selectedCompanies.length == 1) {
                        this.selected.companies = '1 company selected'
                        this.countHiddenCompanies = ''
                    } else {
                        //let countCompanies = this.selectedCompanies.length;
                        this.countHiddenCompanies = '...'
                        this.selected.companies = this.selectedCompanies.length + ' companies selected'
                    }
                } else {
                    this.countHiddenCompanies = ''
                    this.selected.companies = 'None selected'
                }

                this.displaySelectedCompanies = this.selectedCompanies.slice(0,1);

            },
            clearCompaniesDropdown() {
                this.companiesList.map(item => {
                    item.selected = false;
                })

                this.displayedCompanies.map(item => {
                    item.selected = false;
                })

                this.selectedCompanies = [];
                this.openedDropdownCompany = false;
                this.selected.companies = 'None selected'
                this.countHiddenCompanies = ''
            },
            openCloseDropdownCompany() {
                if (!this.openedDropdownCompany)
                    this.openedDropdownCompany = true;
                else
                    this.openedDropdownCompany = false;
            },
            closeDropdownCompany() {
                if (this.openedDropdownCompany)
                    this.openedDropdownCompany = false;
            },
            isAllRowSelected() {
                if (this.selectedCompanies.length == this.displayedCompanies.length) {
                    return true
                } else {
                    return false;
                }
            },
            goBackToUsersPermissions() {
                this.$router.push('/admin/users-permissions')
            },
            changeSuperAdmin() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        let parsedData = {}
                        if (this.firstName != this.initialData.firstName) {
                            parsedData.firstName = this.firstName
                        }
                        if (this.lastName != this.initialData.lastName) {
                            parsedData.lastName = this.lastName
                        }
                        if (this.email != this.initialData.email) {
                            parsedData.email = this.email
                        }

                        let permissionChanged = false

                        for (let i = 0; i < this.initialCompanyPermissions.length; i++) {
                            if (this.initialCompanyPermissions[i].selected != this.companyPermissions[i].selected) {
                                permissionChanged = true
                            }
                        }

                        for (let i = 0; i < this.initialAdminPermissions.length; i++) {
                            if (this.initialAdminPermissions[i].selected != this.adminPermissions[i].selected) {
                                permissionChanged = true
                            }
                        }

                        if (this.initialData.role.roleId != this.roleId) {
                            parsedData.roleId = this.roleId
                        }

                        if (permissionChanged) {
                            parsedData.permissions = []
                            for (let perm of this.companyPermissions) {
                                if (perm.code == 'ALL_COMPANIES_ACCESS') {
                                    if (perm.selected == 'ALL_COMPANIES_ACCESS') {
                                        parsedData.permissions.push(perm.selected)
                                    }
                                } else {
                                    if (perm.selected) {
                                        parsedData.permissions.push(perm.code)
                                    }
                                }
                            }
                            for (let perm of this.adminPermissions) {
                                if (perm.selected) {
                                    parsedData.permissions.push(perm.code)
                                }
                            }
                        }

                        let companiesSelectedChanged = false

                        if (this.selectedCompanies.length > 0 && this.initialData.associatedCompanyIds == undefined) {
                            companiesSelectedChanged = true
                        } else if (this.selectedCompanies.length != this.initialData.associatedCompanyIds.length) {
                            companiesSelectedChanged = true
                        } else if (this.selectedCompanies.length == this.initialData.associatedCompanyIds.length) {
                            for (let company of this.selectedCompanies) {
                                if (this.initialData.associatedCompanyIds.indexOf(company.value) == -1) {
                                    companiesSelectedChanged = true
                                }
                            }
                        }

                        if (companiesSelectedChanged && this.companiesAccess == 'ONLY_SELECTED_COMPANIES') {
                            parsedData.associatedCompanies = []
                            for (let company of this.selectedCompanies) {
                                parsedData.associatedCompanies.push(company.value)
                            }
                        }

                        if ((this.companiesAccess != this.initialCompaniesAccess) && this.companiesAccess == '') {
                            parsedData.associatedCompanies = []
                        }

                        if (Object.keys(parsedData).length === 0) {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'No changes have been made',
                                text: 'Please, press cancel button to leave.',
                                duration: 5000,
                            });
                        } else {
                            Axios.patch(globalStore.data.restApiUrl + '/admin/users/new/' + this.initialData.userId, parsedData)
                                .then(response => {
                                    this.$notify({
                                        type: 'success',
                                        group: 'notification',
                                        title: 'Update successfully made',
                                        text: 'This user account has been updated.',
                                        duration: 5000,
                                    });
                                    this.goBackToUsersPermissions()
                                })
                                .catch(error => {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'User update error',
                                        text: 'Something went wrong during updating user.',
                                        duration: 5000,
                                    });
                                    console.log(error)
                                })
                        }
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Validation error',
                            text: 'Some fields has incorrect values.',
                            duration: 5000,
                        });
                    }
                })
            },
            checkChanges() {
                let changedUserData = false
                if (this.firstName != this.initialData.firstName) {
                    changedUserData = true
                }
                if (this.lastName != this.initialData.lastName) {
                    changedUserData = true
                }
                if (this.email != this.initialData.email) {
                    changedUserData = true
                }

                let changedRole = false

                if (this.initialData.role.roleId != this.roleId) {
                    changedRole = true
                }

                let permissionChanged = false

                for (let i = 0; i < this.initialCompanyPermissions.length; i++) {
                    if (this.initialCompanyPermissions[i].selected != this.companyPermissions[i].selected) {
                        permissionChanged = true
                    }
                }

                for (let i = 0; i < this.initialAdminPermissions.length; i++) {
                    if (this.initialAdminPermissions[i].selected != this.adminPermissions[i].selected) {
                        permissionChanged = true
                    }
                }

                let companiesSelectedChanged = false
                if (this.selectedCompanies.length > 0 && this.initialData.associatedCompanyIds == undefined) {
                    companiesSelectedChanged = true
                } else if (this.selectedCompanies.length != this.initialData.associatedCompanyIds.length) {
                    companiesSelectedChanged = true
                } else if (this.selectedCompanies.length == this.initialData.associatedCompanyIds.length) {
                    for (let company of this.selectedCompanies) {
                        if (this.initialData.associatedCompanyIds.indexOf(company.value) == -1) {
                            companiesSelectedChanged = true
                        }
                    }
                }

                return (changedUserData || permissionChanged || companiesSelectedChanged || changedRole)
            },
            cancelEdition() {
                if (this.checkChanges()) {
                    this.$refs['unsaved'].show()
                } else {
                    this.goBackToUsersPermissions();
                }
            },
            setInitialValues() {
                this.initialData = this.$session.get('editUserData')
                this.disabled = this.initialData.disabled
                this.roleId = this.initialData.role.roleId;
                if (this.initialData.associatedCompanyIds.length > 0) {
                    this.companiesAccess = 'ONLY_SELECTED_COMPANIES'
                    this.initialCompaniesAccess = 'ONLY_SELECTED_COMPANIES'
                }
                this.firstName = this.initialData.firstName
                this.lastName = this.initialData.lastName
                this.email = this.initialData.email
                this.getCompaniesList();
            },
            showDisableUserModal() {
                this.$refs['disableUserModal'].show();
            },
            disableUser() {
                Axios.patch(globalStorage.data.restApiUrl + '/admin/accounts/' + this.initialData.userId + '/disabled/true')
                    .then(response => {
                        if (response.status == 200 || response.status == 204) {
                            this.disabled = true
                            this.$refs['disableUserModal'].hide();
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'User disabled',
                                text: 'User account has been successfully disabled.',
                                duration: 5000,
                            });
                        }
                    })
                    .catch(error => {
                        this.$refs['disableUserModal'].hide();
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'User not disabled',
                            text: 'Something went wrong during disabling user account. Please, contact support.',
                            duration: 5000,
                        });
                        console.log(error);
                    })
            },
            showResetPasswordModal() {
                this.$refs['resetPassword'].show()
            },
            hideResetPasswordModal() {
                this.$refs['resetPassword'].hide()
            },
            resetAdminPassword() {
                let emailToReset = {
                    email: this.email
                }

                Axios.post(globalStore.data.restApiUrl + '/register/resetPassword', emailToReset)
                    .then(response => {
                        this.hideResetPasswordModal()
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Reset password done',
                            text: 'Password Reset Email Sent Successfully',
                            duration: 5000,
                        });
                    }).catch(error => {
                    this.hideResetPasswordModal()

                    if (error.response.status != 429) {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Reset password not working',
                            text: 'Error Resetting Password - Contact Support',
                            duration: 5000,
                        });
                    }
                })
            },
            reactivateUser() {
                Axios.patch(globalStorage.data.restApiUrl + '/admin/accounts/' + this.initialData.userId + '/disabled/false')
                    .then(response => {
                        if (response.status == 200 || response.status == 204) {
                            this.disabled = false
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'User reactivated',
                                text: 'User account has been successfully reactivated.',
                                duration: 5000,
                            });
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'User not reactivated',
                            text: 'Something went wrong during reactivated user account. Please, contact support.',
                            duration: 5000,
                        });
                        console.log(error);
                    })
            }
        },
        created() {
            this.getPermissionsList();
            this.setInitialValues();
        },
        beforeDestroy() {
            this.$session.remove('editUserData')
        }
    }
</script>

<style lang="scss">
    .edit-super-admin {
        .card {
            .card-body {
                display: flex;
                padding: 0;
                .left-side {
                    display: flex;
                    flex-direction: column;
                    width: 400px;
                    padding: 20px 0;
                    border-right: 1px solid #c8ced3;
                    h3.title-header {
                        margin: 0 0 22px;
                        padding: 0 20px;
                        font-size: 14px;
                        font-weight: 700;
                    }

                    h4.title-header {
                        margin: 20px 0 12px;
                        padding: 0 20px;
                        font-size: 14px;
                        font-weight: 700;
                    }

                    .section-header {
                        font-size: 15px;
                        padding: 0 20px;
                        font-weight: 400;
                    }

                    select.form-control {
                        max-width: calc(100% - 40px);
                        margin: 0 20px;
                    }

                    fieldset {
                        padding: 0 20px;
                        &.error-field {
                            .validate-warning {
                                color: #fc4d4d;
                            }
                        }
                    }

                    .reset-pswd-btn {
                        width: 200px;
                        margin: 20px auto 0;
                    }

                    .disable-btn-box {
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-end;
                        align-items: flex-start;
                        .btn {
                            margin: 0 20px;
                            &.hidden {
                                display: none;
                            }
                        }
                        .btn-error {
                            color: #ffffff;
                            background-color: #fc4d4d;
                            border-color: #fc4d4d;
                            font-weight: 700;
                        }
                    }
                }
                .right-side {
                    padding: 20px 0;
                    flex-grow: 1;

                    .title-header {
                        margin: 0;
                        padding: 0 20px;
                        font-size: 14px;
                        font-weight: 700;
                    }

                    .permissions-subtitle {
                        padding: 0 20px;
                        margin: 30px 0 17px;
                        font-size: 14px;
                        font-weight: 700;
                    }

                    .permissions-checkboxes {
                        padding: 0 20px;
                        .permission-item {
                            display: flex;
                            align-items: center;
                            &.hide-perm {
                                display: none;
                            }
                            .radio-box {
                                margin: 6px 0;

                                input[type="radio"] {
                                    display: none;

                                    &:checked + label::after {
                                        content: '';
                                        display: inline-block;
                                        position: absolute;
                                        left: 4px;
                                        top: 4px;
                                        width: 8px;
                                        height: 8px;
                                        margin-right: 8px;
                                        background-color: #2F353A;
                                        border-radius: 50%;
                                    }
                                }

                                label {
                                    position: relative;
                                    display: flex;
                                    margin: 0;

                                    &::before {
                                        content: '';
                                        display: inline-block;
                                        width: 16px;
                                        height: 16px;
                                        border: 2px solid #2F353A;
                                        border-radius: 50%;
                                        margin-right: 8px;
                                    }
                                }
                            }
                            .radio-box,
                            .checkbox-box {
                                width: 200px;
                                margin-right: 50px;
                            }
                            .description {
                                color: #515B65;
                            }
                        }
                        .companies-select-dropdown {
                            margin: 20px 0 0;
                            padding: 0 20px;
                        }
                    }
                    .control-bar {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 20px 20px 0;
                        a {
                            color: #0088FF;
                            font-weight: 700;
                            cursor: pointer;
                        }
                        .buttons-box {
                            .btn {
                                &:first-child {
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    #unsaved___BV_modal_content_ ,
    #disableUserModal___BV_modal_content_ {
        .modal-header {
            padding-bottom: 0;
        }

        .modal-body {
            padding: 0 1rem 1rem;
            text-align: center;

            i {
                color: #0088FF;
                margin-bottom: 15px;
            }

            img {
                height: 19px;
                width: auto;
                margin-bottom: 15px;
            }

            h3 {
                display: block;
                margin-bottom: 18px;
                font-size: 15px;
                line-height: 18px;
                font-weight: 700;
                color: #2F353A;
            }

            h4 {
                display: block;
                margin-bottom: 20px;
                font-size: 14px;
                line-height: 24px;
                color: #515B65;
            }

            .button-wrapper {
                button {
                    margin: 0 5px;
                    padding-left: 15px;
                    padding-right: 15px;
                }
            }
        }
    }

    #resetPassword {
        .modal-header {
            padding-bottom: 0;
        }

        .modal-body {
            padding-top: 0;
            text-align: center;
            position: static;

            i {
                color: #0088FF;
                margin-bottom: 15px;
            }

            img {
                width: 15px;
                margin-bottom: 15px;
            }

            h3 {
                display: block;
                margin-bottom: 18px;
                font-size: 15px;
                line-height: 18px;
                font-weight: 700;
                color: #2F353A;
            }

            h4 {
                display: block;
                margin-bottom: 40px;
                font-size: 14px;
                line-height: 24px;
                color: #515B65;
            }

            .button-wrapper {
                button {
                    margin: 0 5px;
                    padding-left: 15px;
                    padding-right: 15px;
                }
            }
        }
    }


    .dark-theme {
        .edit-super-admin {
            .card {
                .card-body {
                    .left-side {
                        border-color: #1a1c1d;
                    }
                    .right-side {
                        .permissions-checkboxes {
                            .permission-item {
                                .radio-box {
                                    input[type="radio"]:checked {
                                        &+label {
                                            &:after {
                                                background-color: #fff;
                                            }
                                        }
                                    }
                                    label {
                                        &:before {
                                            border-color: #fff;
                                        }
                                    }
                                }
                                .description {
                                    color: #ffffff;
                                }
                            }
                        }
                        .control-bar {
                            border-color: #1a1c1d;
                        }
                    }
                }
            }
        }

        #resetPassword {
            .modal-body {
                h3 {
                    color: #fff;
                }
                h4 {
                    color: #fff;
                }

                .reseting-password {
                    background-color: rgba(0, 0, 0, 0.7);
                }
            }
        }
    }

</style>
